export const state = () => ({
	records: [],
});

export const mutations = {
	setRecords(state: any, payload: any) {
		state.records = payload;
	},
};

export const getters = {
	getRecords: (state: any) => state.records,
};

export const actions = {
	async getRecords(state: any) {
		const company_uuid = this.$auth.user.company.uuid;

		return new Promise((resolve, reject) => {
			this.$axios
				.get(`/api/company/${company_uuid}/token-records`)
				.then((res) => {
					state.commit('setRecords', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
